// extracted by mini-css-extract-plugin
module.exports = {"articlesGrid":"Articles_articlesGrid__0kbS2","showWide":"Articles_showWide__ja9v3"};